import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { Title } from '../components'
import { scrollToID } from '../../common/lib/static-page/dom-helper'

class StaticPage extends React.Component {
  componentDidMount() {
    // Decode entities in the URL
    window.location.hash = window.decodeURIComponent(window.location.hash)
    const hashParts = window.location.hash.split('#')
    if (hashParts.length > 1) {
      const hash = hashParts.slice(-1)[0]
      scrollToID(hash)
    }
  }

  render() {
    const { intl, viewer } = this.props

    return (
      <div className="static">
        <Title message="Vobo" />
        <div className="landing">
          <div className="landing-content">
            <h2 className="landing-quote">
              {intl.formatMessage(messages.quote)}
            </h2>
            <p className="landing-description">
              {intl.formatMessage(messages.description)}
            </p>
            <Link to={viewer ? '/app' : '/first-test'}>
              <button className="button start-button big-button">
                {intl.formatMessage(messages.cta)}
              </button>
            </Link>
            <Link className='landing-content-student-link' to='/student-landing'>
              {intl.formatMessage(messages.studentCta)}
            </Link>
          </div>
          <div className="flex-column">
            {/*
            <ul>
              <li>{intl.formatMessage(messages.tutorial1)}</li>
              <li>{intl.formatMessage(messages.tutorial2)}</li>
              <li>{intl.formatMessage(messages.tutorial3)}</li>
            </ul>
            */}
            <img
              alt="Computer room"
              className="computer-room-landing"
              src="/assets/images/landing-tutorial.png"
            />
          </div>
        </div>
        {/*
        <div id="static-description" className="description">
          <h3>{intl.formatMessage(messages.grammarTitle)}</h3>
          <p>
            <Link to='/grammar'>{intl.formatMessage(messages.grammarLink)}</Link>
          </p>
        </div>
        
        <div id="static-description" className="description">
          <h3>Čo je Vobo?</h3>
          <p>
            Aplikácia, kde si môžete vytvárať vlastné cvičenia a zdielať ich s ostatnými učiteľmi.
            Z cvičení si môžete vytvoriť testy, ktoré aplikácia opraví za Vás :)
          </p>
        </div>
        <div className="benefits">
          <div className="benefit highlighted-benefit">
            <div className="benefit-info">
              <h3>Šetrí Vám čas.</h3>
              <p>
                Odpadne Vám zdĺhavé opravovanie testov a
                navyše môžete použiť testy od iných učiteľov.
              </p>
            </div>
            <img src="/assets/images/time.png" alt="" />
          </div>
          <div className="benefit">
            <img src="/assets/images/statistics.png" alt="" />
            <div className="benefit-info">
              <h3>Ľahko dostupné výsledky žiakov.</h3>
              <p>
                Pri každom teste uvidíte výsledky každého žiaka a
                zároveň aj jednotlivé odpovede.
              </p>
            </div>
          </div>
          <div className="benefit highlighted-benefit">
            <div className="benefit-info">
              <h3>Nemusíte kopírovať testy.</h3>
              <p>Zbavíte sa množstva papierov a ušetríte aj životné prostredie.</p>
            </div>
            <img src="/assets/images/tree.png" alt="" />
          </div>
        </div>
        <div className="try-app">
          <h3>Zaujalo vás to?</h3>
          <Link to="/sign-up">
            <button className="button start-button big-button filled-green-button">
              Vyskúšať
            </button>
          </Link>
        </div>
        */}
      </div>
    )
  }
}

StaticPage.defaultProps = {
  viewer: null,
}

StaticPage.propTypes = {
  intl: PropTypes.object.isRequired,
  viewer: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
  }), { }),
  injectIntl,
)

export default enhance(StaticPage)

const messages = defineMessages({
  quote: {
    id: 'static.page.quote',
    defaultMessage: 'Vytvorené pre zaneprázdnených učiteľov',
  },
  description: {
    id: 'static.page.description',
    defaultMessage: 'Vieme, že opravovanie testov je otravné. Nechajte opraviť testy aplikáciu za Vás. Ušetrite papier a čas s Vobo.',
  },
  cta: {
    id: 'static.page.cta',
    defaultMessage: 'Vytvoriť test',
  },
  studentCta: {
    id: 'static.page.studentCta',
    defaultMessage: 'Som študent',
  },
  tutorial1: {
    id: 'static.page.tutorial1',
    defaultMessage: 'Vytvorte test z predpripravených cvičení alebo svojich vlastných',
  },
  tutorial2: {
    id: 'static.page.tutorial2',
    defaultMessage: 'Test dostane pridelenú adresu na, ktorej bude dostupný pre žiakov na vyplnenie',
  },
  tutorial3: {
    id: 'static.page.tutorial3',
    defaultMessage: 'Po vyplnení žiakmi sa výsledky automaticky zobrazia',
  },
  grammarTitle: {
    id: 'static.page.grammarTitle',
    defaultMessage: 'Vysvetlenia gramatiky',
  },
  grammarLink: {
    id: 'static.page.grammarLink',
    defaultMessage: 'Pozrite si vysvetlenia gramatiky.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/StaticPage.js